import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import francais from 'vuetify/es5/locale/fr'

const opts = {
    icons: {
        iconfont: 'mdiSvg',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary:   '#1565C0',
                secondary: '#424242',
                accent:    '#82B1FF',
                error:     '#FF5252',
                info:      '#2196F3',
                success:   '#4CAF50',
                warning:   '#FFC107'
            },
            dark: {
                primary:   '#1565C0',
                secondary: '#424242',
                accent:    '#82B1FF',
                error:     '#FF5252',
                info:      '#2196F3',
                success:   '#4CAF50',
                warning:   '#FFC107'
            }
        }
    },
    lang: {
        locales: { francais },
        current: 'francais',
    },
}

export default new Vuetify( opts );
